import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Language } from '../Types/language.type';

const DAY_FIRST = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{2}|\d{4})$/;

export function toDateLocale(language: Language): string {
  return language === 'fr' ? 'fr' : 'en-GB';
}

function toFullYear(digits: string): number {
  const currentCentury = Math.floor(new Date().getFullYear() / 100) * 100;

  return digits.length === 4 ? Number(digits) : currentCentury + Number(digits);
}

@Injectable()
export class EuropeanDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (typeof value !== 'string') {
      return super.parse(value);
    }

    const match = DAY_FIRST.exec(value.trim());

    if (!match) {
      return super.parse(value);
    }

    const day = Number(match[1]);
    const month = Number(match[2]);
    const parsed = new Date(toFullYear(match[3]), month - 1, day);

    return parsed.getMonth() === month - 1 && parsed.getDate() === day ? parsed : this.invalid();
  }
}
